// import Google Analitycs
const keyGA = 'G-291WWRFET7'

export function navigationGA(title, location, path) {
  // Google Analitycs Navigation application
  const gtag = window.gtag
  gtag('config', keyGA, {
    page_title: title,
    page_location: location,
    page_path: path,
  })
}
